import {AgencyRepositoryType} from "../../../repositories/interfaces/AgencyRepositoryType.ts";
import {AgencyObservation} from "../../entities/Agency.ts";

export class UpdateAgencyObservationUseCase {
    constructor(private readonly agencyRepository: AgencyRepositoryType) {}

    execute(agencyId: string, observationId: string, text: string): Promise<AgencyObservation> {
        return this.agencyRepository.updateAgencyObservation(agencyId, observationId, text.trim())
    }
}
